<template>
    <div>
        <div class="title">{{ $t('configuration_management.reserved_instance_purchase.title') }}</div>
        <table-reserved-instance-purchase></table-reserved-instance-purchase>
    </div>
</template>

<script>
    import TableReservedInstancePurchase from '../reserved_instance_purchase/TableReservedInstancePurchase'

    export default {
        name: 'ReservedInstancePurchase',
        components: {
            TableReservedInstancePurchase
        }
    }
</script>

<style scoped>
    .title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/reserved_instance_purchase/ReservedInstancePurchase.vue